/**
 * Utility functions for tenant management
 */

/**
 * Get current tenant context from localStorage
 * @returns tenant name or null
 */
export function getCurrentTenant(): string | null {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('current_tenant');
  }
  
  return null;
}

/**
 * Set current tenant in localStorage
 * @param tenantName tenant name
 */
export function setCurrentTenant(tenantName: string): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem('current_tenant', tenantName);
  }
}

/**
 * Clear current tenant from localStorage
 */
export function clearCurrentTenant(): void {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('current_tenant');
  }
}
